import React, { useState, useRef, useEffect } from 'react';
import './frameNewback.css';
import { useParams } from 'react-router-dom';
import axios from "axios"
import { Box, Paper, Stack } from "@mui/material";
import TextRenderer from './TextRender';
import Tooltip from '@mui/material/Tooltip';
const SreeChatID = () => {

    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    let obj = {};
    for (let pair of params.entries()) {
        obj[pair[0]] = pair[1];
    }
    const preview = obj["preview"];
    const domain = obj["domain"];
    const [selectedlanguage, setselectedlanguage] = useState("en");
    const [showChatBot, setShowChatBot] = useState(preview ? true : false);
    const urlParams = useParams()
    const selectRef = useRef(null);
    const inputRef = useRef(null);
    const [isSoundOn, setIsSoundOn] = useState(true);
    const { companyName, chatId, avatarName } = urlParams;
    const capitalizedName = avatarName ? avatarName.charAt(0).toUpperCase() + avatarName.slice(1).toLowerCase() : "Avatar";
    const [hideChatInput, sethideChatInput] = useState(true)
    const [messages, setMessages] = useState([]);
    const [chatHistory, setChatHistory] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(true);
    const [isRecordingTemp, setIsRecordingTemp] = useState(false);
    const messagesEndRef = useRef(null);
    const mediaRecorderRefTemp = useRef(null);
    const recordedChunksRefTemp = useRef([]);
    const mediaStreamRefTemp = useRef(null);
    const [recentBotIndex, setRecentBotIndex] = useState(null);
    const [recordMessage, setRecordMessage] = useState(false);
    const videoRef = useRef(null);
    const videoRef3 = useRef(null);
    const videoRef2 = useRef(null);
    const audioConstraintsTemp = {
        audio: {
            sampleRate: 16000,
            channelCount: 1,
            echoCancellation: false,
            noiseSuppression: false,
            autoGainControl: false,
        },
    };
    const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isSafari = () => {
        const ua = navigator.userAgent.toLowerCase();
        return ua.includes('safari') && !ua.includes('chrome');
    };
    const handleIconClick = () => {

        if (selectRef.current) {

            selectRef.current.focus(); // Focus first
            selectRef.current.click(); // Then click
        }
    };
    useEffect(() => {
        if (!preview) {
            callApiOnPageLoad("hi", 'onloadtime')
        }
        handleVideoPathmute()
        getNumberUserID();
    }, [])
    useEffect(() => {
        const latestBotIndex = messages
            .map((item, index) => (item.type === 'bot' ? index : null))
            .filter(index => index !== null)
            .pop();
        if (latestBotIndex !== null) {
            setRecentBotIndex(latestBotIndex);
        }
    }, [messages]);
    useEffect(() => {
        const timer = setTimeout(() => {
            setRecordMessage(false);
        }, 3000);
        return () => clearTimeout(timer);
    }, [recordMessage]);
    const audioRef = useRef(null);
    const base64ToBlob = (base64Data, contentType = '', sliceSize = 512) => {
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    };
    const canvasRef = useRef(null);
    const audioContextRef = useRef(null);
    const animationRef = useRef(null);

    const [micLevel, setMicLevel] = useState([]);
    const [micstart, setMicstart] = useState(false);
    const stopAudioStatusRef = useRef(false);
    const sendAudioToApi = async (status) => {
        if (status == false) {
            stopAudioStatusRef.current = true; // mark that we are stopping manually
            recordedChunksRefTemp.current = [];
            mediaRecorderRefTemp.current?.stop();
            mediaStreamRefTemp.current?.getTracks().forEach((track) => track.stop());
            setIsRecordingTemp(false);
            return;
        }
        stopAudioStatusRef.current = false;
        if (!isRecordingTemp) {
            try {
                if (micstart == false) { inputRef.current?.focus(); }

                mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
                const mimeType = isIOS() || isSafari() ? 'audio/mp4' : 'audio/webm';
                if (!MediaRecorder.isTypeSupported(mimeType)) {
                    console.warn(`${mimeType} is not supported on this browser. Falling back to a supported type.`);
                    return;
                }
                mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType });
                mediaRecorderRefTemp.current.ondataavailable = (event) => {
                    if (event.data.size > 0) {
                        recordedChunksRefTemp.current.push(event.data);
                    }
                };

                const audioContext = new (window.AudioContext || window.webkitAudioContext)();
                const microphone = audioContext.createMediaStreamSource(mediaStreamRefTemp.current);
                const analyser = audioContext.createAnalyser();

                microphone.connect(analyser);
                analyser.fftSize = 256;
                const bufferLength = analyser.frequencyBinCount;
                const dataArray = new Uint8Array(bufferLength);


                const updateMicLevel = () => {
                    analyser.getByteFrequencyData(dataArray);

                    const bars = 20;
                    const newAudioData = [];
                    const binSize = Math.floor(bufferLength / bars);

                    for (let i = 0; i < bars; i++) {
                        let sum = 0;
                        const start = i * binSize;
                        const end = Math.min(start + binSize, bufferLength);

                        for (let j = start; j < end; j++) {
                            sum += dataArray[j];
                        }

                        // Normalize and enhance the values
                        const average = sum / (end - start);
                        const normalized = Math.min(average / 255 * 100, 100);
                        newAudioData.push(normalized);
                    }

                    setMicLevel(newAudioData);
                    requestAnimationFrame(updateMicLevel);
                };

                updateMicLevel();
                mediaRecorderRefTemp.current.onstop = async () => {
                    if (stopAudioStatusRef.current) {
                        console.log("Stopped manually, skipping API call.");
                        stopAudioStatusRef.current = false; // reset
                        return;
                    }
                    setMicstart(true)
                    const blobTemp = new Blob(recordedChunksRefTemp.current, { type: mimeType });
                    recordedChunksRefTemp.current = [];
                    const readerTemp = new FileReader();
                    readerTemp.readAsDataURL(blobTemp);

                    readerTemp.onloadend = async () => {
                        setRecordMessage(true)
                        const base64AudioTemp = readerTemp.result.split(',')[1];
                        const formDataTemp = new FormData();
                        formDataTemp.append('audio_file', base64AudioTemp);
                        formDataTemp.append('file_extension', mimeType === 'audio/mp4' ? 'mp4' : 'webm');
                        try {
                            const responseTemp = await fetch(`https://speech.pranathiss.com/api/vad-base64-speech-to-text-v2/${selectedlanguage}/`, {
                                method: 'POST',
                                body: formDataTemp,
                            });
                            const resultTemp = await responseTemp.json();
                            setRecordMessage(false)

                            if (resultTemp.response) {

                                const transcribedText = resultTemp.response;

                                if (isSessionstarted == false) {
                                    setisSessionstarted(true)
                                    callApiOnPageLoad(transcribedText, "", selectedlanguage, false);
                                } else {
                                    callApiOnPageLoad(transcribedText, "", selectedlanguage, true);
                                }
                            }

                        } catch (error) {
                            console.log(`Error: ${error.message}`);
                        }
                    };
                };
                mediaRecorderRefTemp.current.start();
                setIsRecordingTemp(true);
            } catch (error) {
                if (error.name === 'NotAllowedError') {
                    console.log('Microphone access was denied. Please enable it in your settings.');
                } else if (error.name === 'NotFoundError') {
                    console.log('No microphone found. Please connect a microphone.');
                } else {
                    console.log(`An unexpected error occurred: ${error.message}`);
                }
            }
        } else {
            mediaRecorderRefTemp.current.stop();
            mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
            setIsRecordingTemp(false);
        }
    };
    const toggleSound = () => {
        let PreisSoundOn = isSoundOn;
        if (audioRef.current && onlyAudio) {
            audioRef.current.muted = PreisSoundOn;

        } else {
            if (videoRef.current) {
                videoRef.current.muted = PreisSoundOn;

            }

            if (videoRef2.current) {
                videoRef2.current.muted = PreisSoundOn;

            }
        }
        setIsSoundOn(!PreisSoundOn)
        sessionStorage.setItem('isSoundOn', !PreisSoundOn)
    };


    const apiBaseUrl = process.env.REACT_APP_API_URL2
    const [form_detailList, setform_detailList] = useState([])
    const [formCount, setformCount] = useState(0)
    const [typingLoading, settypingLoading] = useState(false)
    const [formvideo, setformvideo] = useState()
    const [formsuccess, setformsuccess] = useState();
    const [onlyAudio, setonlyAudio] = useState(false)
    const languages = [
        {
            "language": "Afrikaans",
            "code": "af"
        },
        {
            "language": "Albanian",
            "code": "sq"
        },
        {
            "language": "Amharic",
            "code": "am"
        },
        {
            "language": "Arabic",
            "code": "ar"
        },
        {
            "language": "Armenian",
            "code": "hy"
        },
        {
            "language": "Azerbaijani",
            "code": "az"
        },
        {
            "language": "Basque",
            "code": "eu"
        },
        {
            "language": "Bengali",
            "code": "bn"
        },
        {
            "language": "Bosnian",
            "code": "bs"
        },
        {
            "language": "Bulgarian",
            "code": "bg"
        },
        {
            "language": "Catalan",
            "code": "ca"
        },
        {
            "language": "Chinese (Simplified)",
            "code": "zh-CN"
        },
        {
            "language": "Croatian",
            "code": "hr"
        },
        {
            "language": "Czech",
            "code": "cs"
        },
        {
            "language": "Danish",
            "code": "da"
        },
        {
            "language": "Dutch",
            "code": "nl"
        },
        {
            "language": "English",
            "code": "en"
        },
        {
            "language": "Estonian",
            "code": "et"
        },
        {
            "language": "Finnish",
            "code": "fi"
        },
        {
            "language": "French",
            "code": "fr"
        },
        {
            "language": "Galician",
            "code": "gl"
        },
        {
            "language": "Georgian",
            "code": "ka"
        },
        {
            "language": "German",
            "code": "de"
        },
        {
            "language": "Greek",
            "code": "el"
        },
        {
            "language": "Hebrew",
            "code": "iw"
        },
        {
            "language": "Hindi",
            "code": "hi"
        },
        {
            "language": "Hungarian",
            "code": "hu"
        },
        {
            "language": "Icelandic",
            "code": "is"
        },
        {
            "language": "Indonesian",
            "code": "id"
        },
        {
            "language": "Irish",
            "code": "ga"
        },
        {
            "language": "Italian",
            "code": "it"
        },
        {
            "language": "Japanese",
            "code": "ja"
        },
        {
            "language": "Javanese",
            "code": "jw"
        },
        {
            "language": "Kannada",
            "code": "kn"
        },
        {
            "language": "Kazakh",
            "code": "kk"
        },
        {
            "language": "Khmer",
            "code": "km"
        },
        {
            "language": "Korean",
            "code": "ko"
        },
        {
            "language": "Lao",
            "code": "lo"
        },
        {
            "language": "Latvian",
            "code": "lv"
        },
        {
            "language": "Lithuanian",
            "code": "lt"
        },
        {
            "language": "Macedonian",
            "code": "mk"
        },
        {
            "language": "Malay",
            "code": "ms"
        },
        {
            "language": "Malayalam",
            "code": "ml"
        },
        {
            "language": "Maltese",
            "code": "mt"
        },
        {
            "language": "Mongolian",
            "code": "mn"
        },
        {
            "language": "Nepali",
            "code": "ne"
        },
        {
            "language": "Norwegian",
            "code": "no"
        },
        {
            "language": "Pashto",
            "code": "ps"
        },
        {
            "language": "Persian",
            "code": "fa"
        },
        {
            "language": "Polish",
            "code": "pl"
        },
        {
            "language": "Portuguese",
            "code": "pt"
        },
        {
            "language": "Romanian",
            "code": "ro"
        },
        {
            "language": "Russian",
            "code": "ru"
        },
        {
            "language": "Serbian",
            "code": "sr"
        },
        {
            "language": "Sinhala",
            "code": "si"
        },
        {
            "language": "Slovak",
            "code": "sk"
        },
        {
            "language": "Slovenian",
            "code": "sl"
        },
        {
            "language": "Somali",
            "code": "so"
        },
        {
            "language": "Spanish",
            "code": "es"
        },
        {
            "language": "Sundanese",
            "code": "su"
        },
        {
            "language": "Swahili",
            "code": "sw"
        },
        {
            "language": "Swedish",
            "code": "sv"
        },
        {
            "language": "Tamil",
            "code": "ta"
        },
        {
            "language": "Telugu",
            "code": "te"
        },
        {
            "language": "Thai",
            "code": "th"
        },
        {
            "language": "Turkish",
            "code": "tr"
        },
        {
            "language": "Ukrainian",
            "code": "uk"
        },
        {
            "language": "Urdu",
            "code": "ur"
        },
        {
            "language": "Uzbek",
            "code": "uz"
        },
        {
            "language": "Vietnamese",
            "code": "vi"
        },
        {
            "language": "Welsh",
            "code": "cy"
        },
        {
            "language": "Zulu",
            "code": "zu"
        }
    ]
    const getNumberUserID = async () => {
        let req = {
            user_id: companyName
        }
        try {
            const response = await fetch(`https://app.avatarchatbots.ai/qxbox/apiV1/get-user-id/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(req),
            });

            if (response.ok) {
                const data = await response.json();
                if (data.user_id) {
                    getUserSubscription(data.user_id)
                }

            }
        } catch (error) {

        }
    }
    const [usersubscription, setusersubscription] = useState({})
    const getUserSubscription = async (id) => {
        const config2 = {
            headers: {
                Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`,
                "Content-Type": "multipart/form-data",
            },
        };

        fetch(`https://admin.avatarchatbots.ai/qxbox/apiV1/get-user-subscription-details/?user_id=${id}`, { method: "GET", headers: config2.headers, })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((res) => {
                if (res.length !== 0) {
                    setusersubscription(res[0])
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }
    const [isSessionstarted, setisSessionstarted] = useState(false);
    const [session_id, setsession_id] = useState()
    const callApiOnPageLoad = async (data, check, language = selectedlanguage, session) => {
        setdisabledSendBtn(false)
        setonlyAudio(false)
        setonloadTime(true)
        setInputValue("")
        settypingLoading(true)
        setLoading2(true)
        let object = {
            isuser: true,
            message: data,
            text: data,
            custom_payloads: [],
            api_details: false,
            api_call: {},
            form_status: false,
            form_details: []
        }

        if (check != "onloadtime") {
            let charts = messages
            charts.push(object)
            setMessages([...charts])
        }

    

        let charthistory21 = chatHistory
        charthistory21.push({human:data});

        setChatHistory([...charthistory21])
        let req = {
            chatbot_id: chatId,
            user_id: companyName,
            chat_history: charthistory21,
            avatar_name: avatarName,
            language: language,

        }
      
        if (session == false && !session_id) {
            req.start_session = true
        }

        if (session_id) {
            req.session_id = session_id
        }

        setTimeout(() => {
            if (messagesEndRef.current) {
                messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }, 300);
        try {
            const response = await fetch(`${apiBaseUrl}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(req),
            });

            if (response.ok) {

                const data = await response.json();
                if (data.session_id) {
                    setsession_id(data.session_id)
                }

                if (data.form_status) {
                    setformCount(0)
                    setform_detailList([...data.form_details])
                    console.log([...data.form_details], 'from response');
                    sethideChatInput(false)
                    setformsuccess(data.responses[0])
                    setformvideo(data.video_path)
                }

                let object = {
                    isuser: false,
                    message: data.form_status ? data.form_message[0] : data.responses[0], // Show form_message if it exists
                    custom_payloads: data.custom_payloads,
                    api_details: data.api_details,
                    api_call: data.api_call,
                    form_status: data.form_status || false,
                    form_details: data.form_status ? data.form_details[0] : [],
                    formSubmited: false

                };


                let charts = messages
                charts.push(object)
                setMessages([...charts])
                let object2 = {
                    ai: data.responses[0]
                }

                let charthistory2s = chatHistory

                charthistory2s.push(object2)

                setChatHistory([...charthistory2s])
                setInputValue("")

                setTimeout(() => {
                    if (messagesEndRef.current) {
                        messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 300);
                if (data.audio_data) {
                    setonlyAudio(true)
                    // Stop any existing audio before playing a new one
                    if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.currentTime = 0;
                        audioRef.current.src = "";
                    }
                    const audioElement = audioRef.current;

                    audioElement.src = 'data:audio/mp3;base64,' + data.audio_data;

                    let sound = sessionStorage.getItem('isSoundOn')
                    audioElement.muted = !isSoundOn;

                    if (videoRef.current) {
                        videoRef.current.src = data.video_path;
                        videoRef.current.muted = true;
                        videoRef.current.loop = false
                        const videoElement = videoRef.current;
                        videoElement.onloadeddata = async () => {
                            try {
                                // Ensure both start from the exact same position
                                audioElement.currentTime = 0;
                                videoElement.currentTime = 0;
                                await Promise.all([videoElement.play(), audioElement.play()]);
                            } catch (error) {
                                console.log("Autoplay failed:", error);
                            }
                        };

                        // Keep them in sync while playing
                        videoElement.onplay = () => {
                            if (data.audio_data) {

                                audioRef.current.muted = !isSoundOn
                                audioElement.currentTime = videoElement.currentTime;
                                audioElement.play();
                            }
                        };

                        videoElement.onpause = () => audioElement.pause();

                        videoElement.onseeked = () => {
                            audioElement.currentTime = videoElement.currentTime;
                        };
                        videoRef.current.onended = () => {
                            audioRef.current.src = ""
                            videoRef.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
                            videoRef.current.muted = true;
                            videoRef.current.loop = true;
                            videoRef.current.play();

                        };
                    }

                    if (videoRef2.current) {
                        videoRef2.current.src = data.video_path;
                        videoRef2.current.muted = true;
                        videoRef2.current.loop = false
                        const videoElement2 = videoRef2.current;
                        videoElement2.onloadeddata = async () => {
                            try {
                                // Ensure both start from the exact same position
                                audioElement.currentTime = 0;
                                videoElement2.currentTime = 0;
                                await Promise.all([videoElement2.play(), audioElement.play()]);
                            } catch (error) {
                                console.log("Autoplay failed:", error);
                            }
                        };

                        // Keep them in sync while playing
                        videoElement2.onplay = () => {
                            if (data.audio_data) {

                                audioRef.current.muted = !isSoundOn
                                audioElement.currentTime = videoElement2.currentTime;
                                audioElement.play();
                            }
                        };

                        videoElement2.onpause = () => audioElement.pause();

                        videoElement2.onseeked = () => {
                            audioElement.currentTime = videoElement2.currentTime;
                        };
                        videoRef2.current.onended = () => {
                            audioRef.current.src = ""
                            videoRef2.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
                            videoRef2.current.muted = true;
                            videoRef2.current.loop = true;
                            videoRef2.current.play();

                        };
                    }
                } else if (data.video_path) {
                    setonlyAudio(false)
                    // Stop any previous audio when switching to a new video
                    if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.currentTime = 0;
                        audioRef.current.src = "";
                    }

                    if (videoRef.current && !data.form_status) {
                        videoRef.current.src = data.video_path;
                        videoRef.current.muted = !isSoundOn;
                        videoRef.current.loop = false
                        videoRef.current.play();

                        videoRef.current.onended = () => {
                            videoRef.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
                            videoRef.current.muted = true;
                            videoRef.current.loop = true;
                            videoRef.current.play();
                        };
                    }
                    if (videoRef2.current && !data.form_status) {
                        videoRef2.current.src = data.video_path;
                        videoRef2.current.muted = !isSoundOn;
                        videoRef2.current.loop = false
                        videoRef2.current.play();

                        videoRef2.current.onended = () => {
                            videoRef2.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
                            videoRef2.current.muted = true;
                            videoRef2.current.loop = true;
                            videoRef2.current.play();
                        };
                    }
                } else {
                    settypingLoading(false)
                }

                settypingLoading(false)


            } else {
                settypingLoading(false)
                const data = await response.json();
                let object = {
                    isuser: false,
                    message: data.message, // Show form_message if it exists

                };
                let charts = messages
                charts.push(object)
                setMessages([...charts])

            }
            setLoading2(false)

            inputRef.current?.focus();
        } catch (error) {
            inputRef.current?.focus();
            let object = {
                isuser: false,
                message: error.response.data.message, // Show form_message if it exists

            };
            let charts = messages
            charts.push(object)
            setMessages([...charts])
            console.log('Fetch error:', error);
            setLoading2(false)
        }
    };
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    useEffect(() => {
        if (!loading2 && !isMobile) {
            // give DOM time to enable input before focusing
            setTimeout(() => {
                inputRef.current?.focus();

            }, 10);
        }
    }, [loading2]);
    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (inputValue) {
            if (isSessionstarted == false) {
                callApiOnPageLoad(inputValue, "", selectedlanguage, false);
            } else {
                callApiOnPageLoad(inputValue, "", selectedlanguage, true);
            }

            setisSessionstarted(true)
        }

    }
    const [onloadTime, setonloadTime] = useState(false)
    const [data, setData] = useState({});
    const [inputValues, setInputValues] = useState({});
    const [disabledSendBtn, setdisabledSendBtn] = useState(false)
    const inputChangeTosubmit = (value, data, index) => {
        let simpledata = data;

        simpledata.map((items, i) => {
            if (index == i) {
                if (!items.type) {
                    items.type = "Charfield"
                } else if (items.type == "Emailfield") {
                    if (!/^\S+@\S+\.\S+$/.test(value)) {
                        items.validation = "Please enter a valid email"
                    } else {
                        items.validation = ""
                    }

                } else if (items.type == "Integerfield") {
                    if (!/^\d{9,12}$/.test(value)) {
                        items.validation = "Please enter a valid phone number (9 to 12 digits)."
                    } else {
                        items.validation = ""
                    }
                } else {
                    if (value) {
                        items.validation = ""
                    } else {
                        items.validation = "Please enter a valid input"
                    }
                }
                items.value = value
            }
            return items
        });
        setform_detailList([...simpledata])

    };
    const handleInputFormSubmit = (e, api_details) => {
        e.preventDefault();

        // Validate Inputs Before Sending

        let simpledata = form_detailList;
        var count = 0
        simpledata.map((items, i) => {
            items.validation = ""
            if (items.value) {
                if (!items.type) {
                    items.type = "Charfield"
                } else if (items.type == "Emailfield") {
                    if (!/^\S+@\S+\.\S+$/.test(items.value)) {
                        items.validation = "Please enter a valid email"
                        count = count + 1
                    }
                } else if (items.type == "Integerfield") {
                    if (!/^\d{9,12}$/.test(items.value)) {
                        items.validation = "Please enter a valid phone number (9 to 12 digits)."
                        count = count + 1
                    }
                }
            } else if (!items.value) {
                items.validation = "Please enter a valid input"
                count = count + 1
            }
        });

        if (count != 0) {
            setform_detailList([...simpledata])
            return false
        }

        const data = form_detailList.reduce((acc, curr) => {
            acc[curr.label] = curr.value;
            return acc;
        }, {});
        const formDataMessage = `Submitted form data: ${Object.entries(data).map(([key, value]) => `${key}: ${value}`).join(', ')}`;
        let charthistory21 = chatHistory;
        charthistory21.push({ human: formDataMessage });
        setChatHistory([...charthistory21]);

        setdisabledSendBtn(true)

        if (api_details && api_details.url) {
            // Proceed with external API call only if URL is available
            if (api_details.method === "POST") {
                axios.post(api_details.url, data)
                    .then(() => {
                        handleFormSuccess();
                        sethideChatInput(true);
                    })
                    .catch((e) => {
                        alert("Your Api URL not valid please check api");
                        sethideChatInput(true);
                        setdisabledSendBtn(false);
                    });
            } else {
                axios.get(api_details.url, { params: data })
                    .then((rep) => {
                        console.log("Response:", rep);
                        handleFormSuccess();
                        sethideChatInput(true);
                    })
                    .catch((e) => {
                        console.log("Error:", e);
                        setdisabledSendBtn(false);
                    });
            }
        } else {
            // If no API URL, just show the success message and send to chat API
            handleFormSuccess();
            sethideChatInput(true);
        }

        // Smooth scroll to bottom
        setTimeout(() => {
            if (messagesEndRef.current) {
                messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }, 300);
    };
    const handleVideoPath = () => {
        if (videoRef.current) {
            videoRef.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
            videoRef.current.muted = !isSoundOn;
            videoRef.current.play();
        }
        if (videoRef2.current) {
            videoRef2.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
            videoRef2.current.muted = !isSoundOn;
            videoRef2.current.play();
        }
    }
    const handleVideoPathmute = () => {
        if (videoRef.current) {
            videoRef.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
            videoRef.current.muted = true;
            videoRef.current.loop = true;
            videoRef.current.play();
        }

        if (videoRef2.current) {
            videoRef2.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
            videoRef2.current.muted = true;
            videoRef2.current.loop = true;
            videoRef2.current.play();
        }
    }
    // Function to handle form success behavior
    const handleFormSuccess = () => {
        let messagelist = messages;
        messagelist.map((message, i) => {
            if (message.form_status) {
                message.formSubmited = true;
            }

            return message
        })
        let object = { isuser: false, message: formsuccess };

        setMessages([...messagelist, object]);

        if (videoRef.current) {


            videoRef.current.src = formvideo;
            videoRef.current.muted = !isSoundOn;
            videoRef.current.play();
            videoRef.current.loop = false;
            videoRef.current.onended = () => {
                videoRef.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
                videoRef.current.muted = true;
                videoRef.current.loop = true;
                videoRef.current.play();
            };
        }

        if (videoRef2.current) {


            videoRef2.current.src = formvideo;
            videoRef2.current.muted = !isSoundOn;
            videoRef2.current.play();
            videoRef2.current.loop = false;
            videoRef2.current.onended = () => {
                videoRef2.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
                videoRef2.current.muted = true;
                videoRef2.current.loop = true;
                videoRef2.current.play();
            };
        }


    };
    //     try {
    //         let charthistory21 = [...chatHistory];
    //         // Create a formatted message with form data
    //         const formMessage = `Form submitted with data: ${Object.entries(formData).map(([key, value]) => `${key}: ${value}`).join(', ')}`;

    //         charthistory21.push({ human: formMessage });
    //         setChatHistory([...charthistory21]);

    //         let req = {
    //             chatbot_id: chatId,
    //             user_id: companyName,
    //             chat_history: charthistory21,
    //             avatar_name: avatarName,
    //             language: selectedlanguage,
    //             form_data: formData,    // Include the form data in the request
    //             video_path:formvideo,
    //         };

    //         if (session_id) {
    //             req.session_id = session_id;
    //         }

    //         const response = await fetch(`${apiBaseUrl}`, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify(req),
    //         });

    //         if (response.ok) {
    //             const responseData = await response.json();

    //             if (responseData.session_id) {
    //                 setsession_id(responseData.session_id);
    //             }

    //             // Add the AI response to messages
    //             let object = {
    //                 isuser: false,
    //                 message: responseData.responses[0],
    //                 custom_payloads: responseData.custom_payloads || [],
    //                 api_details: responseData.api_details || false,
    //                 api_call: responseData.api_call || {},
    //                 form_status: responseData.form_status || false,
    //                 form_details: responseData.form_status ? responseData.form_details[0] : [],
    //                 formSubmited: false
    //             };

    //             let charts = [...messages];
    //             charts.push(object);
    //             setMessages(charts);

    //             // Add the AI response to chat history
    //             let object2 = {
    //                 ai: responseData.responses[0]
    //             };

    //             let charthistory2s = [...chatHistory];
    //             charthistory2s.push(object2);
    //             setChatHistory([...charthistory2s]);

    //             // Handle video/audio response if present
    //             if (responseData.audio_data || responseData.video_path) {
    //                 handleMediaResponse(responseData);
    //             }

    //             console.log('Form data sent to chat API successfully:', responseData);
    //         } else {
    //             console.error('Failed to send form data to chat API');
    //         }
    //     } catch (error) {
    //         console.error('Error sending form data to chat API:', error);
    //     }
    // };

    const handleMediaResponse = (data) => {
        if (data.audio_data) {
            setonlyAudio(true);
            // Stop any existing audio before playing a new one
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
                audioRef.current.src = "";
            }
            const audioElement = audioRef.current;
            audioElement.src = 'data:audio/mp3;base64,' + data.audio_data;
            audioElement.muted = !isSoundOn;

            if (videoRef.current) {
                videoRef.current.src = data.video_path;
                videoRef.current.muted = true;
                videoRef.current.loop = false;
                const videoElement = videoRef.current;
                videoElement.onloadeddata = async () => {
                    try {
                        audioElement.currentTime = 0;
                        videoElement.currentTime = 0;
                        await Promise.all([videoElement.play(), audioElement.play()]);
                    } catch (error) {
                        console.log("Autoplay failed:", error);
                    }
                };

                videoElement.onplay = () => {
                    if (data.audio_data) {
                        audioRef.current.muted = !isSoundOn;
                        audioElement.currentTime = videoElement.currentTime;
                        audioElement.play();
                    }
                };

                videoElement.onpause = () => audioElement.pause();
                videoElement.onseeked = () => {
                    audioElement.currentTime = videoElement.currentTime;
                };

                videoRef.current.onended = () => {
                    audioRef.current.src = "";
                    videoRef.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`;
                    videoRef.current.muted = true;
                    videoRef.current.loop = true;
                    videoRef.current.play();
                };
            }

            if (videoRef2.current) {
                // Similar logic for videoRef2
                videoRef2.current.src = data.video_path;
                videoRef2.current.muted = true;
                videoRef2.current.loop = false;
                const videoElement2 = videoRef2.current;
                videoElement2.onloadeddata = async () => {
                    try {
                        audioElement.currentTime = 0;
                        videoElement2.currentTime = 0;
                        await Promise.all([videoElement2.play(), audioElement.play()]);
                    } catch (error) {
                        console.log("Autoplay failed:", error);
                    }
                };

                videoElement2.onplay = () => {
                    if (data.audio_data) {
                        audioRef.current.muted = !isSoundOn;
                        audioElement.currentTime = videoElement2.currentTime;
                        audioElement.play();
                    }
                };

                videoElement2.onpause = () => audioElement.pause();
                videoElement2.onseeked = () => {
                    audioElement.currentTime = videoElement2.currentTime;
                };

                videoRef2.current.onended = () => {
                    audioRef.current.src = "";
                    videoRef2.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`;
                    videoRef2.current.muted = true;
                    videoRef2.current.loop = true;
                    videoRef2.current.play();
                };
            }
        } else if (data.video_path) {
            setonlyAudio(false);
            // Stop any previous audio when switching to a new video
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
                audioRef.current.src = "";
            }

            if (videoRef.current) {
                videoRef.current.src = data.video_path;
                videoRef.current.muted = !isSoundOn;
                videoRef.current.loop = false;
                videoRef.current.play();

                videoRef.current.onended = () => {
                    videoRef.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`;
                    videoRef.current.muted = true;
                    videoRef.current.loop = true;
                    videoRef.current.play();
                };
            }
            if (videoRef2.current) {
                videoRef2.current.src = data.video_path;
                videoRef2.current.muted = !isSoundOn;
                videoRef2.current.loop = false;
                videoRef2.current.play();

                videoRef2.current.onended = () => {
                    videoRef2.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`;
                    videoRef2.current.muted = true;
                    videoRef2.current.loop = true;
                    videoRef2.current.play();
                };
            }
        }

        // Smooth scroll to bottom
        setTimeout(() => {
            if (messagesEndRef.current) {
                messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }, 300);
    };


    const languageselection = (value) => {
        setselectedlanguage(value)
    }
    const [hideshow, sethideshow] = useState(false)
    const hidetextformImage = () => {
        sethideshow(true)
    }

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [expandChat, setexpandChat] = useState(false)

    // console.log(messages, 'messages');

    return (
        <>

            <div className={`${preview ? "chartbotinsideopen preview" : "chartbotinsideopen"} ${expandChat ? "active" : ""}`.trim()} >
                <div className={!showChatBot ? 'containers' : "d-none"} id='ChatBotContainer'>
                    <div className='headAndOutput'>

                        <div className="d-block d-md-none">
                            <div className="chatHead  justify-content-start align-items-start" style={{ padding: "0px 10px" }}>
                                <div className="headIcontext">
                                    <div className="group-2"></div>
                                    <div className="iconHeadChat">
                                        <div className="imageHolderchat inmobileVideoPlay" style={{ backgroundImage: `url(https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.jpg)`, backgroundSize: "94px 173px", }}   >
                                            <video className="staticVideoClass" width="100%" autoPlay ref={screenWidth < 768 ? videoRef2 : videoRef3} playsInline  ></video>
                                        </div>

                                    </div>
                                </div>
                                <div className="headMinClose headTextClass d-grid ps-3 mt-4">
                                    <p className="miniHead"  >Chat With</p>
                                    <p className='font-sizemim'>{capitalizedName}</p>

                                </div>
                                <div className='closeiconsandexpnd'>
                                    <div style={{ position: "relative" }}>
                                        {usersubscription.is_multi_langual_chat ?
                                            <div className="custom-select">
                                                <label htmlFor='languagesselect' onClick={handleIconClick}>
                                                    {selectedlanguage.toUpperCase()}
                                                </label>
                                                <select className='languagesselect' id="languagesselect" title='language selection' onChange={(e) => languageselection(e.target.value)} value={selectedlanguage} >
                                                    {languages.map((lan, i) => {
                                                        return (
                                                            <option value={lan.code} key={"Lang" + i}>{lan.language}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div> : ""}
                                    </div>
                                    {!isSoundOn ? <Tooltip title="Unmute Audio"><span onClick={() => { toggleSound(); }} className='iconsbackground2 '     >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-volume-x"><path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"></path><line x1="22" x2="16" y1="9" y2="15"></line><line x1="16" x2="22" y1="9" y2="15"></line></svg>
                                    </span></Tooltip> :
                                        <Tooltip title="Mute Audio"><span className='iconsbackground2 ' onClick={() => { toggleSound(); }}   >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-volume-2"><path d="M11 5L6 9H2v6h4l5 4V5z"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>
                                        </span></Tooltip>}
                                    {/* <div className='close-top'  onClick={() => { setexpandChat(!expandChat); }}>
                                        <span className="iconsbackground2"  >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrows-angle-expand" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707" />
                                            </svg>
                                        </span>
                                    </div> */}
                                    <div className='close-top' style={{ width: "45px" }} >
                                        {preview ? <Tooltip title="Close Chat"><span className="iconsbackground2" onClick={() => {setShowChatBot(!showChatBot); stop();setIsRecordingTemp(false) }} >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                            </svg>
                                        </span></Tooltip> : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='d-none d-md-block'>
                            <div className='chatHead '>
                                <div className='headIcontext'>
                                    <div className='group-2'></div>
                                    <div className='iconHeadChat'>
                                        <div className='imageHolderchat' >
                                            <img src={`https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.jpg`} alt="Avatar" />
                                        </div>

                                        <div className='headTextClass'>
                                            <div className="text-wrapper miniHead">Chat with</div>
                                            <div className="font-sizemim">{capitalizedName}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='headMinClose'>
                                    <div className='languagesDivBoth'>
                                        <div className='' style={{ position: 'relative' }} >
                                            {usersubscription.is_multi_langual_chat ?
                                                <div className="custom-select">
                                                    <label htmlFor='languagesselect' onClick={handleIconClick}>
                                                        {selectedlanguage.toUpperCase()}
                                                    </label>
                                                    <select className='languagesselect' id="languagesselect" title='language selection' onChange={(e) => languageselection(e.target.value)} value={selectedlanguage} >
                                                        {languages.map((lan, i) => {
                                                            return (
                                                                <option value={lan.code} key={"Lang" + i}>{lan.language}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </div> : ""}
                                        </div>
                                    </div>
                                    <div className=' speakerIconButton' onClick={() => { toggleSound(); }} >
                                        {!isSoundOn ? <Tooltip title="Unmute Audio"><span onClick={() => { toggleSound(); }} className='iconsbackground'  >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-volume-x"><path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"></path><line x1="22" x2="16" y1="9" y2="15"></line><line x1="16" x2="22" y1="9" y2="15"></line></svg>
                                        </span></Tooltip> :
                                            <Tooltip title="Mute Audio"><span className='iconsbackground'   >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-volume-2"><path d="M11 5L6 9H2v6h4l5 4V5z"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>
                                            </span></Tooltip>}
                                        <Tooltip title="Close chat"><span className='iconsbackground'
                                         onClick={(e) => {
                                            e.stopPropagation(); 
                                            setShowChatBot(!showChatBot);
                                            if (mediaRecorderRefTemp.current) {
                                                mediaRecorderRefTemp.current.stop(); 
                                            }
                                            if (mediaStreamRefTemp.current) {
                                                mediaStreamRefTemp.current.getTracks().forEach(track => track.stop()); 
                                            }
                                            setIsRecordingTemp(false); 
                                            stop(); 
                                        }}
                                            style={preview ? {} : { opacity: 0 }} >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
                                        </span>
                                        </Tooltip>

                                    </div>


                                </div>
                            </div>
                        </div>
                        <div id="output-container">
                            <div className="messages-container">
                                <audio ref={audioRef} controls style={{ display: "none" }}  > Your browser does not support the audio element. </audio>
                                {messages.map((item, index) => (
                                    <div key={"Message" + index} className={`message-item ${item.isuser ? 'sender' : 'receiver'}`}>

                                        {!item.formSubmited &&
                                            <div className='senderIconText'>

                                                <div className="message">
                                                    {recordMessage && index === recentBotIndex ? (
                                                        <div className="chat-bubble-audio">
                                                            <div className="typing">
                                                                <div className="dot"></div>
                                                                <div className="dot"></div>
                                                                <div className="dot"></div>
                                                            </div>
                                                        </div>
                                                    ) :
                                                        <>
                                                            <div className=''>
                                                                <TextRenderer text={item.message} domain={domain} />
                                                            </div>
                                                            {item.form_status == false && item?.custom_payloads?.length !== 0 && item?.custom_payloads?.map((elem, index) => (
                                                                <div className='response-options' key={"custom" + index}>
                                                                    <button onClick={() => callApiOnPageLoad(elem.name)} type='button'>  {elem.name} </button>
                                                                </div>
                                                            ))}
                                                            {item.form_status ?
                                                                <>
                                                                    <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                                                                        <Paper elevation={3} sx={{ p: 3, width: "100%", maxWidth: 400, border: "2px solid #90b832", borderRadius: "6px", }} >
                                                                            <Stack spacing={2}>
                                                                                {form_detailList.map((item2, index2) => (
                                                                                    <div key={index2}>
                                                                                        <input
                                                                                            id={`input-${index2}`}
                                                                                            type="text"
                                                                                            name={item2.label.toLowerCase()}
                                                                                            disabled={disabledSendBtn}
                                                                                            onChange={(e) => inputChangeTosubmit(e.target.value, form_detailList, index2)}
                                                                                            placeholder={item2.label}
                                                                                            style={{ width: "100%", padding: "8px", borderRadius: "6px", outline: "none", fontSize: "16px", }}
                                                                                        />
                                                                                        {item2.validation && (
                                                                                            <span style={{ color: "red", fontSize: "12px", marginTop: "4px", display: "block" }}>
                                                                                                {item2.validation}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                ))}

                                                                                {/* Send Button (Aligned Bottom-Right) */}
                                                                                {!disabledSendBtn ? <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                                                                                    <button className='sendbutton'
                                                                                        onClick={() => {

                                                                                            if (item.api_details) {
                                                                                                handleInputFormSubmit(event, item.api_details);
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <h3>Send</h3>
                                                                                    </button>
                                                                                </Box> : <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                                                                                    <button disabled={true} className='disbaledButton sendbutton' style={{ backgroundColor: "#c9c6c6", cursor: "none" }}>
                                                                                        <h3>Send</h3>
                                                                                    </button>
                                                                                </Box>}
                                                                            </Stack>
                                                                        </Paper>
                                                                    </Box>


                                                                </>
                                                                : ""}
                                                        </>
                                                    }


                                                </div>
                                                {item.isuser && <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                                                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                                                    <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1" />
                                                </svg>}
                                                {item.isuser === false && <div className='imageHolderchat' style={{ marginRight: "0px" }}> <img src={`https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.jpg`} alt="Avatar" /> </div>}
                                            </div>}
                                        <div ref={messagesEndRef} />
                                    </div>
                                ))}
                                {recordMessage && (
                                    <div className="chat-bubble-audio">
                                        <div className="typing">
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                        </div>
                                    </div>
                                )}
                                {typingLoading ? <div className="chat-bubble-audio">
                                    <div className="typing">
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                    </div>
                                </div> : ""}
                                <div ref={messagesEndRef} />
                            </div>

                            <div className="hello-container backgroundclass " style={{ backgroundImage: `url(https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.jpg)` }} >
                                <video className="staticVideoClass" width="100%" autoPlay ref={screenWidth > 768 ? videoRef : videoRef3} playsInline ></video>
                            </div>

                        </div>
                    </div>
                    {hideChatInput ?
                        <div className='outputHelpfulClass'>

                            {isRecordingTemp ? (
                                <form onSubmit={handleFormSubmit} className="input-container">

                                    <div className="chat-input">
                                        <div className="waves">
                                            {micLevel.map((height, i) => (
                                                <span
                                                    key={i}
                                                    className="bg-gradient-to-t from-blue-600 to-blue-400 rounded-t-sm transition-all duration-75 ease-out"
                                                    style={{
                                                        width: '4px',
                                                        height: `${Math.max(height * 0.8 + 10, 4)}%`, // Minimum 4% height

                                                    }}
                                                />
                                            ))}




                                        </div>

                                    </div>
                                    <div className='iconButton icn-btnhvr' onClick={() => sendAudioToApi(false)} disabled={loading} >
                                        <Tooltip title="Cancel" placement="top">
                                            <svg width="40" height="40" className='audio-cancel icon' viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-label="Stop dictation" fontSize="inherit"><path d="M14.2548 4.75488C14.5282 4.48152 14.9717 4.48152 15.2451 4.75488C15.5184 5.02825 15.5184 5.47175 15.2451 5.74512L10.9902 10L15.2451 14.2549L15.3349 14.3652C15.514 14.6369 15.4841 15.006 15.2451 15.2451C15.006 15.4842 14.6368 15.5141 14.3652 15.335L14.2548 15.2451L9.99995 10.9902L5.74506 15.2451C5.4717 15.5185 5.0282 15.5185 4.75483 15.2451C4.48146 14.9718 4.48146 14.5282 4.75483 14.2549L9.00971 10L4.75483 5.74512L4.66499 5.63477C4.48589 5.3631 4.51575 4.99396 4.75483 4.75488C4.99391 4.51581 5.36305 4.48594 5.63471 4.66504L5.74506 4.75488L9.99995 9.00977L14.2548 4.75488Z"></path></svg>
                                        </Tooltip>

                                    </div>
                                    <div className='iconButton icn-btnhvr' onClick={() => sendAudioToApi(true)} disabled={loading}  >
                                        <Tooltip title="Send Audio" placement="top">
                                            {/* <svg
                                            width="46"
                                            height="46"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="black"
                                        >
                                            <path d="M16.1475 9.3525C16.2528 9.45797 16.312 9.60094 16.312 9.75C16.312 9.89906 16.2528 10.042 16.1475 10.1475L10.8975 15.3975C10.792 15.5028 10.6491 15.562 10.5 15.562C10.3509 15.562 10.208 15.5028 10.1025 15.3975L7.8525 13.1475C7.75314 13.0409 7.69905 12.8998 7.70162 12.7541C7.70419 12.6084 7.76323 12.4693 7.86629 12.3663C7.96935 12.2632 8.10839 12.2042 8.25411 12.2016C8.39984 12.199 8.54087 12.2531 8.6475 12.3525L10.5 14.2041L15.3525 9.3525C15.458 9.24716 15.6009 9.18799 15.75 9.18799C15.8991 9.18799 16.042 9.24716 16.1475 9.3525ZM21.5625 12C21.5625 13.8913 21.0017 15.7401 19.9509 17.3126C18.9002 18.8852 17.4067 20.1108 15.6594 20.8346C13.9121 21.5584 11.9894 21.7477 10.1345 21.3788C8.27951 21.0098 6.57564 20.099 5.2383 18.7617C3.90096 17.4244 2.99022 15.7205 2.62125 13.8656C2.25227 12.0106 2.44164 10.0879 3.16541 8.34059C3.88917 6.59327 5.11482 5.09981 6.68736 4.04907C8.25991 2.99833 10.1087 2.4375 12 2.4375C14.5352 2.44048 16.9658 3.44891 18.7584 5.24158C20.5511 7.03425 21.5595 9.46478 21.5625 12ZM20.4375 12C20.4375 10.3312 19.9427 8.69992 19.0155 7.31238C18.0884 5.92484 16.7706 4.84338 15.2289 4.20477C13.6871 3.56615 11.9906 3.39906 10.3539 3.72462C8.71722 4.05019 7.2138 4.85378 6.03379 6.03379C4.85379 7.21379 4.05019 8.71721 3.72463 10.3539C3.39907 11.9906 3.56616 13.6871 4.20477 15.2289C4.84338 16.7706 5.92484 18.0884 7.31238 19.0155C8.69992 19.9426 10.3312 20.4375 12 20.4375C14.237 20.435 16.3817 19.5453 17.9635 17.9635C19.5453 16.3817 20.435 14.237 20.4375 12Z" />
                                        </svg> */}

                                            <svg width="40" height="40" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="icon-lg"><path d="M15.4835 4.14551C15.6794 3.85999 16.069 3.78747 16.3545 3.9834C16.6401 4.17933 16.7126 4.56897 16.5167 4.85449L8.9688 15.8545C8.86289 16.0088 8.69334 16.1085 8.50689 16.125C8.32053 16.1415 8.13628 16.0737 8.00494 15.9404L3.55377 11.4219L4.00005 10.9824L4.44634 10.542L8.36431 14.5176L15.4835 4.14551ZM3.55962 10.5352C3.80622 10.2922 4.20328 10.2955 4.44634 10.542L3.55377 11.4219C3.31073 11.1752 3.31297 10.7782 3.55962 10.5352Z"></path></svg>
                                        </Tooltip>


                                    </div   >


                                </form>

                            ) :
                                <form onSubmit={handleFormSubmit} className="input-container">
                                    <input type="text" ref={inputRef} value={inputValue} onChange={(e) => setInputValue(e.target.value)} placeholder="Enter your message" disabled={loading2} />
                                    {isRecordingTemp ? (
                                        <div className="recording-indicator">
                                            <div onClick={sendAudioToApi} disabled={loading} className='iconButton' >
                                                <Tooltip title="Cancel">
                                                    <svg width="46" height="46" fill="none" stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="m3 3 18 18"></path>
                                                        <path d="M12.87 12.874A3 3 0 0 1 9 10.002v-1"></path>
                                                        <path d="M9 5a3 3 0 1 1 6 0v5c0 .296-.044.59-.13.874"></path>
                                                        <path d="M17.848 13.85A6.967 6.967 0 0 0 19 10"></path>
                                                        <path d="M5 10a7 7 0 0 0 10.846 5.85"></path>
                                                        <path d="M8 21h8"></path>
                                                        <path d="M12 17v4"></path>
                                                    </svg> 
                                                </Tooltip>

                                            </div>
                                        </div>
                                    ) : (
                                        <div className='iconButton btnhvr' onClick={sendAudioToApi} disabled={loading}  >
                                            <Tooltip title="Record Audio" placement="top">
                                                <svg width="46" height="46" fill="none" stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15 5a3 3 0 1 0-6 0v5a3 3 0 1 0 6 0V5Z"></path>
                                                    <path d="M5 10a7 7 0 1 0 14 0"></path>
                                                    <path d="M8 21h8"></path>
                                                    <path d="M12 17v4"></path>
                                                </svg>
                                            </Tooltip>

                                        </div>
                                    )}
                                    <button type='submit' className='sendbuttonstyle btnhvr' disabled={loading} style={{ background: "none", paddingRight: "4px", marginTop: "4px", borderRadius: "50%", marginLeft: "3px" }} >
                                        <Tooltip title="Send Message" placement='top'><span className=' ' >
                                            <svg width="25" height="25" fill="none" stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 14 21 3"></path>
                                                <path d="m21 3-6.5 18a.55.55 0 0 1-1 0L10 14l-7-3.5a.55.55 0 0 1 0-1L21 3Z"></path>
                                            </svg> 
                                        </span></Tooltip>

                                    </button>
                                </form>}
                        </div> : ""}

                    {usersubscription.watermark ? <div className='powerdby'>
                        Powered by <a href='https://avatarchatbots.ai/' target='_blank'>Avatar Chat Agents</a>
                    </div> : ""}
                </div>
            </div >

            <div className={!showChatBot ? 'd-none' : " chatBoxImageClass"} >
                {!hideshow ? <div className='positionclassin'>
                    <h2>Hello! 🎉 Let’s get started. What’s on your mind?</h2>
                    <div className='closeicon' onClick={() => hidetextformImage()}> ❌</div>
                </div> : ""}
                <div className='avatarimageHolder'>
                    <img src={`https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.gif`} alt="" onClick={() => { setShowChatBot(!showChatBot); !onloadTime ? callApiOnPageLoad("hi", 'onloadtime') : ""; handleVideoPath() }} />
                </div>
            </div>

        </>
    );
}

export default SreeChatID;